import ContentfulService from '../base/ContentfulService';
import IUser from '../../types/base/auth/IUser';
import Role from '../../types/base/auth/Role';

export default class UserService extends ContentfulService {
	public async getCurrentUser(): Promise<IUser> {
		await this.managementClient;

		const salesManagerIds: string[] = (process.env.SALES_MANAGER_USER_IDS || '').split(',');
		const user = await this.managementClient.getCurrentUser();

		return {
			...user,
			role: salesManagerIds.includes(user.sys.id) ? Role.SalesManager : Role.SalesRepresentative
		};
	}
}
